/**
 * @description 用户列表表格列头配置
 * @returns {Array} 表格列配置数组
 */
export default function () {
  /* 表格列头配置 */
  return [
    // 序号列
    { label: "序号", type: "index", width: 80 },

    // 所属公众号
    { label: "所属公众号", prop: "account_name", width: 150 },

    // 用户昵称
    { label: "用户昵称", prop: "user_name", width: 80, slots: "user_name" },

    // 用户公众号openid
    { label: "用户公众号openid", prop: "gzh_openid", minWidth: 120, slots: "gzh_openid" },

    // 用户小程序openid
    { label: "用户小程序openid", prop: "openid", minWidth: 100, slots: "openid" },

    // 创建时间
    {
      label: "创建时间",
      prop: "create_time",
      width: 180
    },

    // 操作列
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      fixed: "right"
    }
  ];
}
